import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import ScrollToTop from "@/components/feature/ScrollToTop";

export default function AboutUsPage() {
  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <Navbar />
      <main className="flex-1 pt-20">
        <section className="w-full px-4 md:px-8 lg:px-16 py-12 md:py-16">
          <div className="max-w-7xl mx-auto">
            <div className="flex flex-col lg:flex-row gap-8 lg:gap-12 items-start">
              {/* Left — Text */}
              <div className="flex-1">
                <h5 className="text-xs font-bold tracking-[0.2em] text-accent-500 uppercase mb-4">
                  OUR APPROACH
                </h5>
                <h2 className="text-3xl md:text-4xl font-bold text-foreground-900 mb-6">
                  Our company is here{" "}
                  <span className="text-accent-500">for help to you</span>
                </h2>
                <div className="space-y-4 text-sm text-foreground-700 leading-relaxed">
                  <p>
                    NW Trucking of NC is a professional trucking and transportation company based in Norwood, NC and founded by Nicholas Watkins. Since the first day we opened our doors for the community of Norwood, NC we have dedicated ourselves to creating a reliable, trustworthy trucking business that the residents of North Carolina can always depend on. We want to provide you with an amazing customer experience and show you how clients should be treated when they are working with a professional trucking company. NW Trucking of NC is not like any other trucking company in Norwood, NC – we are the best among the best for a large number of reasons. We provide our clientele with specialty trucking services and a large array of services to choose from – as we know how important reliable transportation is for your business and personal needs.
                  </p>
                  <p>
                    We want to become the Norwood, NC trucking company that you always give a call to when you need transportation services – no matter how simple or complex it may be. Ranging from local hauling, residential transportation, commercial freight and storage solutions – we also offer professional loading assistance that you can always request from us – and we will always deliver. We at NW Trucking of NC know how to approach your transportation needs, listen to your wishes and requirements and apply the best approach that will enable you to sit back and relax during your entire shipment. There are a lot of trucking companies in Norwood, NC – but none like NW Trucking of NC. You might be wondering what sets us apart from every other Norwood, NC trucking company out there…
                  </p>
                </div>
              </div>

              {/* Right — Images */}
              <div className="flex-1 flex flex-col gap-4">
                <img
                                  src="/images/h2.jpg"
                  alt="NW Trucking of NC"
                  className="w-full h-auto"
                />
                <img
                                  src="/images/s2.jpg"
                  alt="Moving professionals"
                  className="w-full h-auto"
                />
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
      <ScrollToTop />
    </div>
  );
}